export default __webpack_public_path__ + "static/media/Deep Chisel.74be5988.png";